/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-28 14:34:40
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-28 14:36:01
 * @FilePath: /unifyxp-v2-store-portal/src/layout/EditorPageLayout/EditorCollapsePageLayout/SizeFittingListener/index.tsx
 */
import React from 'react';
import { ChangeSize } from 'src/tools/customHooks';
import { useDispatch } from 'react-redux';
import { setContentWidth } from 'src/layout/store';

const Listener = (props) => {
  const { id } = props;
  const _d = useDispatch();
  const contentSize = ChangeSize(id);
  // React.useEffect(() => {
  //   return () => {
  //     _d(setContentWidth(0));
  //   };
  // }, []);
  React.useEffect(() => {
    _d(setContentWidth(contentSize));
  }, [contentSize]);
  return null;
};
export default Listener;
